import React from 'react'
import { Link } from 'react-router-dom'


import image from '../../images/about/about1.jpeg'
import icon from '../../images/ab-icon.png'
import paws1 from '../..//images/paws-6.png'
import paws2 from '../..//images/paws-7.png'

const About = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section id={props.sectionId} className={"" + props.hclass}>
            <div className="wraper">
                <div className="left">
                    <div className="image">
                        <img src={image} alt="" />
                        <div className="shape">
                            <svg width="793" height="786" viewBox="0 0 793 786" fill="none">
                                <path
                                    d="M84.9007 505.664C-181.681 609.802 245.585 843.801 512.633 772.246C713.751 718.356 833.104 511.631 779.214 310.513C725.325 109.395 552.6 -41.9576 351.482 11.9319C150.364 65.8214 351.482 401.526 84.9007 505.664Z"
                                    fill="#FFEFEB" />
                            </svg>
                        </div>
                    </div>
                    <div className="about-video">
                        <div className="icon">
                            <img src={icon} alt="" />
                        </div>
                        <h2>La tecnologia al servizio del tuo gatto.</h2>
                        <p>
                            Kleeo monitora la salute del tuo micio e garantisce una casa fresca e senza odori, 24 ore su 24.
                        </p>
                    </div>
                </div>
                <div className="right">
                    <span>Sicurezza e Design</span>
                    <h2>Kleeo: Progettata per essere la più sicura.</h2>

                    <p>A differenza delle comuni lettiere a rotazione totale, Kleeo adotta un design a cupola fissa con cilindro interno protetto.
                        Questo elimina ogni fessura esterna in movimento, annullando il rischio di schiacciamento e garantendo una protezione totale.</p>

                    <p>Costruita con materiali premium e dotata di un ingresso di soli 14cm per facilitare l'accesso,
                        Kleeo è la lettiera più silenziosa della sua categoria (meno di 45dB), ideale anche per i gatti più timorosi.</p>

                    <div className="about-btn">
                        <Link onClick={ClickHandler} to="/come-funziona" className="theme-btn-s2">Scopri di più</Link>
                    </div>
                </div>
            </div>
            <div className="shape">
                <img src={paws1} alt="" />
            </div>
            <div className="shape-2">
                <img src={paws2} alt="" />
            </div>
        </section>
    )
}

export default About;


